import handleResponse from './request/handleResponse'

export default function fetchRentLicenses(api: GlobalFetch) {
  return async function(calendarId) {
    const buildUrl = `/api/v2/room/license?id_calendar=${calendarId}`
    const response = await api.fetch(buildUrl)

    return await handleResponse(response)
  }
}

export interface IData {
  messages: string[]
  items: Array<Array<IItemData>>
}

export interface IItemData {
  created_at: string
  id: string
  id_calendar: string
  license_str: string
  selection_type: string
  rooms: string[]
}
